// @flow
import {gameVarsModule} from 'us-csg-game-common';

type TSetNextInProcess = {payload: boolean, type: 'SET_NEXT_IN_PROCESS'};
type TSetNextStartTimeout = {type: 'SET_NEXT_START_TIMEOUT'};
type TSetNextEndTimeout = {type: 'SET_NEXT_END_TIMEOUT'};
type TSetIsPaused = {payload: boolean, type: 'SET_IS_PAUSED_TIMER'};
type TSetBackSlideInProcess = {payload: boolean, type: 'SET_BACK_SLIDE_IN_PROCESS'};
type TSetIsShownEndTournamentModal = {type: 'SET_IS_SHOWN_END_TOURNAMENT_MODAL'};
type TSetIsShownSkipChampModal = {type: 'SET_IS_SHOWN_SKIP_CHAMP_MODAL'};
type TSetIsNotShownSkipChampModal = {type: 'SET_IS_NOT_SHOWN_SKIP_CHAMP_MODAL'};
type TSetIsTutorialSkip = {payload: boolean, type: 'SET_IS_TUTORIAL_SKIP'};
type TSetGeigerCloudCheckUserResult = {payload: boolean, type: 'SET_GEIGER_CLOUD_CHECK_USER_RESULT'};

type TGameVarsActionList =
    | TSetNextInProcess
    | TSetIsNotShownSkipChampModal
    | TSetIsShownSkipChampModal
    | TSetIsShownEndTournamentModal
    | TSetBackSlideInProcess
    | TSetNextEndTimeout
    | TSetNextStartTimeout
    | TSetIsTutorialSkip
    | TSetGeigerCloudCheckUserResult;

// eslint-disable-next-line complexity
function gameVarsReducer(state: Object, action: TGameVarsActionList) {
    switch (action.type) {
        case 'SET_IS_TUTORIAL_SKIP':
            return {
                ...state,
                isTutorialSkip: true,
            };
        case 'SET_NEXT_IN_PROCESS':
            return {
                ...state,
                nextInProcess: action.payload,
            };
        case 'SET_IS_SHOWN_END_TOURNAMENT_MODAL':
            return {
                ...state,
                isShownEndTournamentModal: true,
            };
        case 'SET_IS_SHOWN_SKIP_CHAMP_MODAL':
            return {
                ...state,
                isShownSkipChampModal: true,
            };
        case 'SET_IS_NOT_SHOWN_SKIP_CHAMP_MODAL':
            return {
                ...state,
                isShownSkipChampModal: false,
            };
        case 'SET_PER_CENT_VOTES':
            return {
                ...state,
                expressVotes: action.payload,
            };
        case 'SET_IS_PAUSED_TIMER':
            return {
                ...state,
                isPaused: action.payload,
            };
        case 'SET_NEXT_END_TIMEOUT':
            return {
                ...state,
                nextInTimeout: false,
            };
        case 'SET_NEXT_START_TIMEOUT':
            return {
                ...state,
                nextInTimeout: true,
            };
        case 'SET_BACK_SLIDE_IN_PROCESS':
            return {
                ...state,
                backSlideInProcess: action.payload,
            };
        case 'SET_GEIGER_CLOUD_CHECK_USER_RESULT':
            return {
                ...state,
                geigerCloudCanPlayGame: action.payload
            }
        default:
            return gameVarsModule.gameVarsReducer(state, action);
    }
}

export {gameVarsReducer};
export type {
    TSetNextInProcess,
    TSetIsPaused,
    // TSetIsNotPaused,
    TSetNextStartTimeout,
    TSetNextEndTimeout,
    TSetIsShownEndTournamentModal,
    TSetIsShownSkipChampModal,
    TSetBackSlideInProcess,
    TSetIsNotShownSkipChampModal,
    TSetIsTutorialSkip,
    TSetGeigerCloudCheckUserResult,
};
